import { Property } from '@/components/form/fields/select/SelectInput';

export const PERIPHERAL_CAT_FILTER_ID = 'peripherals';

export const DEFAULT_SORT_OPTION = {
  id: 'all',
  name: 'All'
};

export type FinanceModelFilterOptions = {
  category: Property | null;
  manufacturer: Property | null;
  type: Property | null;
  term: Property | null;
};
